import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/plus.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Path = () => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      clipRule: "evenodd",
      d: "M4 11.75C4 11.3358 4.32561 11 4.72727 11H19.2727C19.6744 11 20 11.3358 20 11.75C20 12.1642 19.6744 12.5 19.2727 12.5H4.72727C4.32561 12.5 4 12.1642 4 11.75Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      clipRule: "evenodd",
      d: "M12.25 4C12.6642 4 13 4.32561 13 4.72727V19.2727C13 19.6744 12.6642 20 12.25 20C11.8358 20 11.5 19.6744 11.5 19.2727V4.72727C11.5 4.32561 11.8358 4 12.25 4Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  )
] });
var Plus = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(Path, {}) });

export {
  Plus
};
